
//import {Vue} from "vue-property-decorator";
//import Component from "vue-class-component";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
//import { http } from "@/config/HttpClient";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { globalStore } from '../../store/globalStore';
import { consultorioService } from '../../services/ConsultorioService';
import { http } from "@/config/HttpClient";
import { AxiosResponse } from "axios";

@Component({
	name: "InformacionClinica",
})

export default class Odontograma extends Vue {
	@Prop() paciente_id!: number
	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();


	
	valid = true;
	fecha = DateTime.now().toFormat('yyyy-MM-dd');
	tipo_denticion = []
	panel = []
	//preguntas_x_clasificacion = []
	cerrada = ['Si','No']
	estado_salud = ['Buena','Mala','regular']
	craneo = ['Dolicocefalo','Mesocefalo','Braquicefalo']
	cara = ['Simetrico','Asimetrico']
	perfil = ['Concavo','Convexo','Recto']
	linea = ['Alta','Normal','Baja']
	glandulas_salivales = ['Permeable','No permeable']
	mal_posicion = ['Ninguno','Leve','Moderada','Severa']
	dimension_vertical = ['Adecuada','Desviada']
	hemorragia = ['Rapido','Tarda']
	ojos = ['Inclinacion cantal medial','Inclinacion cantal positiva','Inclinacion cantal negativa']
	nariz = ['Pequeña','Mediana','Grande','Recta','Desviada','Aguileña']
	labios = ['Delgado','Mediano','Grueso']
	ganglios_linfaticos = ['Palpables','No palpables']
	linea_labial = ['Alta','Normal','Baja']
	frenilllos = ['Alta','Media','Baja']
	paladar = ['Plano','Medio','Profundo']
	lengua = ['Pequeña','Mediana','Grande']
	dimension = ['Normal','Alterada']
	protusion = ['Efectiva','No efectiva']
	respuestas = []

	// get paciente() {
	// 	return this.consultorioStore.paciente;
	// }
	get preguntas_x_clasificacion() {
		return this.consultorioStore.preguntas;
	}
	mounted() {
		this.getPreguntas();
		if(this.paciente_id)
		setTimeout(this.getRespuestas,1500);

	}
	async getPreguntas() {
		await http.get('get-preguntas',{params: { ficha: 'HISTORIAL' }}).subscribe({
			next: (response:AxiosResponse) => {
				this.consultorioStore.preguntas = response.data;
			},
		})
	}
	async getRespuestas() {
		await http.get(`get-respuestas-paciente/${this.paciente_id}`).subscribe({
			next: (response:AxiosResponse) => {
				this.respuestas = response.data;
				this.cargarDatos()
			},
		})
	}
	select_opciones(tipo:string,pregunta:string) {
		let opciones = []
		switch (tipo) {
			case 'CERRADA':
				opciones = this.cerrada
				break;
			case 'SELECCION':
				if(pregunta == 'Como considera su estado de salud')
					opciones = this.estado_salud;
				if(pregunta == 'Craneo')
					opciones = this.craneo;
				if(pregunta == 'Cara')
					opciones = this.cara;
				if(pregunta == 'Perfil')
					opciones = this.perfil;
				if(pregunta == 'Linea labial superior')
					opciones = this.linea;
				if(pregunta == 'Glandulas salivales')
					opciones = this.glandulas_salivales;
				if(pregunta == 'Mal Posiciones dentarias')
					opciones = this.mal_posicion;
				if(pregunta == 'Dimension Vertical')
					opciones = this.dimension_vertical;
				if(pregunta == 'Al sufrir un accidente la hemorragia disminuye de manera')
					opciones = this.hemorragia;
				if(pregunta == 'Ojos')
					opciones = this.ojos;
				if(pregunta == 'Nariz')
					opciones = this.nariz;
				if(pregunta == 'Labios')
					opciones = this.labios;
				if(pregunta == 'Ganglios Linfaticos')
					opciones = this.ganglios_linfaticos;
				if(pregunta == 'Linea Labial Superior' || pregunta == 'Linea Labial Inferior' )
					opciones = this.linea_labial;
				if(pregunta == 'Frenillos' )
					opciones = this.frenilllos;
				if(pregunta == 'Paladar Duro' )
					opciones = this.paladar;
				if(pregunta == 'Lengua' )
					opciones = this.lengua;
				if(pregunta == 'Glandulas Salivales' )
					opciones = this.glandulas_salivales;
				if(pregunta == 'Mal posiciones dentarias' )
					opciones = this.mal_posicion;
				if(pregunta == 'Dimension Vertical' || pregunta == 'Apertura bucal' )
					opciones = this.dimension;
				if(pregunta == 'Protusion' || pregunta == 'Lateralidad derecha' || pregunta == 'Lateralidad izquierda' )
					opciones = this.protusion;
				break;
			default:
				break;
		}
		return opciones;
	}
	
	guardar() {
		// if (!this.$refs.form.validate()) {
		// 	Alert.warning(`Lene todos los campos obligatorios (*)`)
		// 	return;
		// }
		
		Alert.confirm(`Se registrar la informacion clinica`, 'Registrar informacion clinica?').then(async result => {
			if (result.isConfirmed) {
				let data = {
					paciente_id: this.paciente_id,
					preguntas_x_clasificacion: this.preguntas_x_clasificacion
				}
				await this.consultorioService.registrarRespuestas(data).then(response => {
				//await this.consultorioService.registrarFicha(data)

					//this.limpiar()
					//this.close()
					//this.listar()
				})

			}
		})

	}

	cargarDatos(){
		this.preguntas_x_clasificacion.forEach(element => {
			element.preguntas.forEach(el => {
				let respuesta = this.respuestas.find(val => val.pregunta_id == el.id)
				if(respuesta){
					//console.log(respuesta)
					el.respuesta = respuesta.respuesta;
					el.observacion = respuesta.observacion
					console.log(el)
				}
			});
		});
		this.panel = []
	}
	async imprimirHistorial() {
		await http.get(`imprimir-historial/${this.paciente_id}`).subscribe(response =>{
					window.open(
						`${process.env.VUE_APP_URL}imprimir-historial/${this.paciente_id}`, "_blank");
						//import.meta.env.VITE_APP_URL +`imprimir-solicitud/${id}`, "_blank");

		})
	}
	
}

